var AccessControlComponent = new JS.Class(EditorComponent, {
  initialize: function(selector, rules, contextPath) {
    this.$access = $(selector);
    this.users = {};
    var that = this;
    $.each(JSON.parse(rules), function(i, user) {
      that.users[user.id] = user;
    });
    var users = {};
    var $custom = $(
      '<div class="modal hide fade"> \
				<div class="modal-header"> \
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button> \
					<h3>Custom Access Control</h3> \
				</div> \
				<div class="modal-body"> \
					<input name="search" type="hidden" class="input-xxlarge" /> \
					<div id="userList"></div> \
				</div> \
				<div class="modal-footer"> \
					<a href="#" class="btn btn-primary">Done</a> \
				</div> \
			</div>'
    ).appendTo(this.$access.parent());

    this.$userList = $custom.find('#userList');
    var $search = $custom
      .find('input[name="search"]')
      .select2({
        placeholder: 'Search for a user or group...',
        minimumInputLength: 3,
        ajax: {
          url: '/json/search/lookup/suggestUserOrCourseGroup/',
          dataType: 'json',
          quietMillis: 250,
          data: function(term, page) {
            return {
              query: term,
              start: (page - 1) * 6,
              coursePath: contextPath,
            };
          },
          results: function(data, page) {
            data = data.result;
            return {
              results: $.map(data.results, function(user) {
                if (users.hasOwnProperty(user.id)) {
                  user = null;
                }
                return user;
              }),
              more: page * 6 < data.total,
            };
          },
        },
        formatResult: function(result) {
          return (
            '<div class="userProfileItem"><img src="' +
            result.icon +
            '" width="24" height="24" align="left"> \
				<div class="name">' +
            result.title +
            ' <span class="profile">' +
            result.id +
            '</span></div> \
				<div style="clear: both;"></div></div>'
          );
        },
        formatSelection: function(result) {
          return result.title;
        },
      })
      .change(function(e) {
        var user = e.added;
        if (user) {
          user.access = 'read'; // give them read access by default
          users[user.id] = user;
          that.updateUserList(users);
        }
      });

    this.$userList.on('change', 'input[type="radio"]', function(e) {
      var $this = $(this);
      var userID = $this.attr('name');
      var access = $this.val();
      users[userID].access = access;
    });

    this.$userList.on('click', '.remove-user', function(e) {
      var userID = $(this).data('id');
      delete users[userID];
      $search.select2('data', null);
      that.updateUserList(users);
    });

    $custom.on('show', function(e) {
      users = $.extend(true, {}, that.users);
      $search.select2('data', null);
      that.updateUserList(users);
    });

    $custom.find('div.modal-footer a.btn-primary').click(function(e) {
      e.preventDefault();
      that.users = users;
      $custom.modal('hide');
    });

    var showPolicyWithIcon = function(policy) {
      var $element = policy.element
        ? $(policy.element)
        : this.element.find('option[value="' + policy.id + '"]');
      var icon = $element.data('icon');
      return (
        '<img src="' +
        imageMedia +
        'icons/16x16/' +
        icon +
        '.png" alt="' +
        icon +
        '" /> ' +
        policy.text
      );
    };

    var deferred = $.Deferred();
    this.$access
      .select2({
        formatResult: showPolicyWithIcon,
        formatSelection: showPolicyWithIcon,
        escapeMarkup: function(markup) {
          return markup;
        },
        width: 'resolve',
      })
      .on('select2-selecting', function(e) {
        if (e.val === 'custom') {
          deferred.done(function() {
            $custom.modal();
          });
        }
      });

    $.ajaxSetup({ cache: true });
    $.getScript(baseMedia + 'lib/dust/compiled_templates/misc.dust').done(
      function() {
        deferred.resolve();
      }
    );
  },

  updateUserList: function(users) {
    var $userList = this.$userList;
    var templateData = {
      accessLevels: [
        {
          name: 'Read',
          value: 'read',
        },
        {
          name: 'Write',
          value: 'write',
        },
        {
          name: 'Admin',
          value: 'admin',
        },
      ],
      users: $.map(users, function(user) {
        return user;
      }),
    };
    dust.render('userList', templateData, function(err, html) {
      var $contents = $userList.contents();
      if ($contents.length) {
        $contents.replaceWith(html);
      } else {
        $userList.append(html);
      }
    });
  },

  getSaveData: function() {
    return {
      AccessControl: {
        policy: this.$access.val(),
        rules: JSON.stringify(
          $.map(this.users, function(user) {
            return user;
          })
        ),
      },
    };
  },
});
